import React from "react";
import Stack from '@mui/material/Stack';


function PageNotFound() {
  return (
    <Stack direction="row" justifyContent="center">
      <img src="/not_found.svg" alt="" />
    </Stack>
  );
}

export default PageNotFound;
